const updateOpenupCtas = () => {
  if (typeof window !== 'undefined' && typeof window.__updateOpenupCtas === 'function') {
    window.__updateOpenupCtas();
  }
};

exports.onRouteUpdate = () => {
  updateOpenupCtas();
  window.setTimeout(updateOpenupCtas, 0);
};
